
// this file loaded in client and server so must be node compatible

module.exports = {
	baseRoute: '',
	publicApiPath: 'https://www.junipernotebook.com/api',
	apiTimeout: 5000
}